import { CLIENT_LOGOS, type ClientLogo } from "@/data/testimonials";

interface ClientLogosProps {
  logos?: ClientLogo[];
}

/** Franja de logos de clientes reales; no se muestra si no hay ninguno. */
export const ClientLogos = ({ logos = CLIENT_LOGOS }: ClientLogosProps) => {
  if (logos.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6 sm:px-8 md:px-12 lg:px-16 text-center">
        <p className="text-primary-dark font-medium tracking-widest uppercase text-sm mb-8">
          Empresas y profesionales que confían
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8">
          {logos.map((l) => (
            <img
              key={l.id}
              src={l.logo}
              alt={l.name}
              loading="lazy"
              className="h-12 md:h-14 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
